import type { SortKey } from '@/constants/companies'

import Button from '@/components/ui/button'
import FilterMenu from '@/components/generals/filter-menu'
import MobileFilters from '@/components/companies/toolbar/mobile-filters'
import { companiesCsvRows, filterCompanies } from '@/lib/companies'
import { downloadCsv } from '@/lib/csv'
import { useCrmStore, useCrmStoreApi } from '@/stores/crm-store-provider'
import ShareIcon from '@/assets/images/companies/toolbar/share.svg'
import PlusIcon from '@/assets/images/_common/plus.svg'

import {
    ACTIVITY_OPTIONS,
    OWNER_OPTIONS,
    SORT_MENU_OPTIONS,
    STAGE_OPTIONS
} from '@/components/companies/toolbar/filter-options'

export default function CompaniesToolbar() {
    const store = useCrmStoreApi()
    const sortBy = useCrmStore(state => state.sortBy)
    const owner = useCrmStore(state => state.owner)
    const stage = useCrmStore(state => state.stage)
    const activityWindow = useCrmStore(state => state.activityWindow)
    const setSortBy = useCrmStore(state => state.setSortBy)
    const setOwner = useCrmStore(state => state.setOwner)
    const setStage = useCrmStore(state => state.setStage)
    const setActivityWindow = useCrmStore(state => state.setActivityWindow)
    const openDialog = useCrmStore(state => state.openDialog)

    function exportCsv() {
        const { companies, today } = store.getState()
        const visible = filterCompanies(companies, { sortBy, owner, stage, activityWindow })

        downloadCsv(`companies-${today}.csv`, companiesCsvRows(visible))
    }

    return (
        <div className='flex shrink-0 flex-wrap items-center justify-between gap-2 px-4 py-4'>
            <MobileFilters className='sm:hidden' />

            <div className='hidden min-w-0 flex-wrap gap-2 sm:flex'>
                <FilterMenu
                    label="Sort by"
                    value={sortBy}
                    options={SORT_MENU_OPTIONS}
                    onChange={value => setSortBy(value as SortKey)}
                />
                <FilterMenu
                    label="Filter"
                    value={owner}
                    options={OWNER_OPTIONS}
                    onChange={setOwner}
                />
                <FilterMenu
                    label="Stage"
                    value={stage}
                    options={STAGE_OPTIONS}
                    onChange={setStage}
                />
                <FilterMenu
                    label="Last Activity"
                    value={String(activityWindow)}
                    options={ACTIVITY_OPTIONS}
                    onChange={value => setActivityWindow(Number(value))}
                />
            </div>

            <div className='flex shrink-0 items-center gap-1'>
                <Button variant='secondary' size='sm' onClick={exportCsv}>
                    <ShareIcon aria-hidden className='size-3' />
                    Export
                </Button>
                <Button variant='primary' size='sm' onClick={() => openDialog('company')}>
                    <PlusIcon aria-hidden className='size-3' />
                    New Company
                </Button>
            </div>
        </div>
    )
}
